import {
  Box,
  Card,
  styled,
  Chip,
  Typography,
  ChipProps,
  Dialog,
} from '@mui/material';

import {
  BaseSyntheticEvent,
  Dispatch,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from 'react';
import ButtonV2 from '@jobseeker/lotus/elements/ButtonV2';
import CircleLoader from '@jobseeker/lotus/components/Loader';

import PersonalizeSearch from './PersonalizeSearch';
import TagsSkeleton from './TagsSkeleton';
import {categories} from './constants';
import {CrossIcon, OrangeTick} from '@jobseeker/lotus/assets/icons';
import {Image} from '@jobseeker/lotus/components/Image';
type CustomChipProps = ChipProps & {
  select?: boolean;
  padding?: string;
  disableRipple?: boolean;
  disableTouchRipple?: boolean;
};

const CustomChipV2 = styled(Chip)<CustomChipProps>(props => ({
  width: 'fit-content',
  '.MuiChip-label': {
    padding: '0px',
  },
  '.MuiChip-deleteIcon': {
    marginRight: '0px',
    marginLeft: '2px',
  },
  border: props?.select ? '1px solid #e9630c' : '1px solid #e6e6e6',
  backgroundColor: props?.select ? '#fffaf0' : '#fff',
  color: props?.select ? '#e9630c' : '#000',
  display: 'inline-block',
  cursor: 'pointer',
  padding: '9px 24px',
  minHeight: '40px',
  borderRadius: '3px',
  lineHeight: '22px',
  fontSize: '16px',
  textAlign: 'center',
  marginRight: 1,
  marginBottom: 1.5,
  position: 'relative',
}));

type Tag = {id: number; name: string; count?: number; select?: boolean};

type PersonalizeTagSelectionType = {
  currentSelectedTags: Array<Tag>;
  handleTagSelection: (
    name: string,
    tagId: number,
    operation: 'SELECT' | 'DESELECT'
  ) => void;
  handleSearch: (query: string) => void;
  handleSubmitConfirm: () => void;
  selectEnabled: boolean;
  updateCalled: boolean;
  resetTags: () => void;
  selectedCount: number;
  toggleSelectedTagsAlert: () => void;
  categorySelected: boolean;
  isMobile: boolean;
  skip: boolean;
  searchValue: string;
  selectedItem?: string | number | undefined;
  selectedCategoryTagsCount?: number;
  personalizedPopUpOpen: boolean;
  setPersonalizedPopUpOpen: Dispatch<SetStateAction<boolean>>;
};

const getCategoryNameById = (id: string | number | undefined) => {
  const category = categories.find(category => category.id === id);
  return category ? category.name : '';
};

const PersonalizeTagSelectionMob = ({
  currentSelectedTags,
  handleTagSelection,
  handleSearch,
  handleSubmitConfirm,
  selectedCount,
  // selectEnabled,
  updateCalled,
  resetTags,
  categorySelected,
  isMobile,
  searchValue,
  selectedItem,
  selectedCategoryTagsCount,
  personalizedPopUpOpen,
  setPersonalizedPopUpOpen,
}: PersonalizeTagSelectionType) => {
  const [searchActive, setSearchActive] = useState(false);
  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

  const onFilterChange = (event: BaseSyntheticEvent) => {
    handleSearch(event.target.value ?? '');
    if (event.target.value?.length) {
      setSearchActive(true);
    } else {
      setSearchActive(false);
    }
  };

  useEffect(() => {
    if (!searchActive) {
      resetTags();
    }
  }, [searchActive]);

  const boxRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (boxRef.current) {
      console.log(boxRef.current, 'boxref');
    }
  }, [boxRef]);

  const ConfirmButton = () => (
    <ButtonV2
      variant="contained"
      sx={{
        marginTop: {xxs: 0},
        height: '48px',
        zIndex: 2,
        width: '100%',
        fontSize: {xxs: 12, xs: 16},
        fontWeight: 500,
        lineHeight: {xxs: '12px', xs: '16px'},
        px: {xxs: 1, md: 2.5},
        py: {xxs: 1.5, md: 1},
        borderRadius: '3px',

        '&:hover': {
          backgroundColor: '#E9630C',
        },

        background: '#E9630C',

        backgroundColor: '#E9630C',
      }}
      onClick={handleSubmitConfirm}
      disabled={selectedCount === 0}
    >
      <Typography fontWeight={'bold'}>
        {!updateCalled ? (
          <Typography fontSize={{xxs: 16}} fontWeight={500}>
            {categorySelected && 'Save & Proceed'}
          </Typography>
        ) : (
          <CircleLoader sx={{color: 'white'}} size={isMobile ? 14 : 16} />
        )}
      </Typography>
    </ButtonV2>
  );

  const PersonalizedFooter = () => (
    <Box
      sx={{
        background: 'white',
        width: '100%',
        height: '80px',
        position: 'fixed',
        bottom: 0,
        mx: 2,
        px: 2.5,
        py: 2.75,
        margin: 'auto',
        display: {xxs: 'block', md: 'flex'},
        alignItems: 'center',
        justifyContent: 'flex-start',
      }}
    >
      <Box>{<ConfirmButton />}</Box>
    </Box>
  );

  return (
    <>
      <Dialog open={personalizedPopUpOpen} fullScreen>
        <Card
          ref={boxRef}
          sx={{
            boxShadow: 2,
            borderRadius: 4,
            marginLeft: {md: 2},
            background: 'none',
            marginTop: 0,
            padding: 0,
          }}
        >
          {categorySelected && (
            <Box
              width="100%"
              sx={{
                py: 2.5,
                height: 'calc(100vh - 60px)',
                overflowY: 'scroll',
                px: 1.25,
              }}
            >
              <>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <Box
                    onClick={() => {
                      setPersonalizedPopUpOpen(false);
                    }}
                    sx={{
                      cursor: 'pointer',
                      position: 'relative',
                      width: '50px',
                      height: '50px',
                      backgroundColor: '#f2f5fa',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '10px',
                      '&:hover': {
                        backgroundColor: 'white',
                        boxShadow: '0 6px 14px 0 rgba(0, 0, 0, 0.09)',
                      },
                    }}
                  >
                    <Image
                      src={CrossIcon}
                      alt="cross-icon"
                      height={12}
                      width={12}
                    />
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: 'column',
                  }}
                >
                  <Box sx={{marginLeft: 1.5}}>
                    <Typography
                      sx={{
                        lineHeight: '32px',
                        fontSize: '24px',
                        fontWeight: 200,
                      }}
                    >
                      {`${selectedCategoryTagsCount} Tags Selected`}{' '}
                    </Typography>
                    <Typography
                      sx={{
                        lineHeight: '32px',
                        fontSize: '24px',
                        fontWeight: 200,
                      }}
                    >
                      <b>
                        {getCategoryNameById(selectedItem)}
                        {getCategoryNameById(selectedItem)?.length > 0
                          ? ' Jobs'
                          : ''}
                      </b>
                    </Typography>
                  </Box>

                  <Box sx={{margin: 1.5}}>
                    {onFilterChange && (
                      <PersonalizeSearch
                        searchValue={searchValue}
                        onFilterChange={onFilterChange}
                        width="100%"
                      />
                    )}
                  </Box>
                </Box>
              </>

              <Box mt={{xxs: 0, md: 2.5}} px={{xxs: 0, md: 3}}>
                <Box display={'flex'} flexWrap={'wrap'} mr={0.625} mb={2}>
                  {currentSelectedTags?.length > 0 ? (
                    currentSelectedTags?.map((tagInfo: Tag, index: number) => {
                      return (
                        <Box
                          ml={1.25}
                          mt={1.25}
                          key={`${index}_${tagInfo.name}`}
                          position="relative"
                        >
                          <CustomChipV2
                            key={`filterchip-filter`}
                            label={tagInfo.name}
                            select={tagInfo.select}
                            disableRipple={isAppIimjobs ? false : true}
                            disableTouchRipple={isAppIimjobs ? false : true}
                            onClick={() => {
                              handleTagSelection(
                                tagInfo.name,
                                tagInfo.id,
                                tagInfo.select ? 'DESELECT' : 'SELECT'
                              );
                            }}
                            sx={
                              tagInfo.select
                                ? {
                                    ':hover': {
                                      backgroundColor: '#fffaf0',
                                    },
                                    cursor: 'pointer',
                                  }
                                : {
                                    ':hover': {
                                      backgroundColor: '#fff',
                                    },
                                    cursor: 'pointer',
                                  }
                            }
                          />
                          {tagInfo.select && (
                            <Image
                              src={OrangeTick}
                              alt="tick"
                              width={21}
                              height={21}
                              style={{
                                position: 'absolute',
                                top: -8,
                                right: -8,
                              }}
                            />
                          )}
                        </Box>
                      );
                    })
                  ) : !searchActive ? (
                    <Box
                      display={'flex'}
                      flexWrap={'wrap'}
                      width={'100%'}
                      mt={1.5}
                    >
                      <TagsSkeleton skeletonChips={65} />
                    </Box>
                  ) : (
                    <Typography
                      px={1.5}
                      mt={{xxs: 1.5, md: 0}}
                      fontSize={{xxs: 14, md: 16}}
                    >
                      Oops! Your search tag might not be listed with us. Please
                      select from listed tags
                    </Typography>
                  )}
                </Box>
              </Box>
            </Box>
          )}
        </Card>

        {(currentSelectedTags?.length > 0 || isMobile) && (
          <PersonalizedFooter />
        )}
      </Dialog>
      ;
    </>
  );
};

export default PersonalizeTagSelectionMob;
